import { useTranslation } from 'next-i18next';
import { useState } from 'react';

import { getTeamCardData } from '@/modules/workingDay/components/Details/TeamList/logic';
import IncidentReportModal from '@/modules/workingDay/components/Details/TeamList/TeamMember/IncidentReportModal';
import { IWorkingDay } from '@/modules/workingDay/types';
import { Button, Typography } from '@/shared/components/atoms';
import DemoCTA from '@/shared/components/atoms/Demo/Modals/DemoCTA';
import { useStore } from '@/shared/hooks/context/createGenericContext';
import { useModal } from '@/shared/hooks/context/modalContext/useModal';

const TeamMember: React.FC<{
  worker: IWorkingDay.IWorker;
  productivityMeasurementUnit: string;
  target: number;
}> = ({ worker, productivityMeasurementUnit, target }) => {
  const { t } = useTranslation('common');
  const [openIncedentModal, setOpenIncedentModal] = useState(false);
  const [isDemoFarm] = useStore((store) => store.isDemoFarm);
  const [incidentReportId, setIncidentReportId] = useState<null | number>(null);

  const { openModal } = useModal();
  const cardData = getTeamCardData(worker, t);

  const showReportClickHandler = (incidentReportId: number | null) => {
    setIncidentReportId(incidentReportId);
    setOpenIncedentModal(true);
  };
  const closeModalHandler = () => {
    setIncidentReportId(null);
    setOpenIncedentModal(false);
  };

  return (
    <div className='flex w-[98%] items-center justify-between gap-2 overflow-x-auto p-16'>
      {Object.entries(cardData).map(([key, value]) => (
        <div key={key} className=' flex w-1/5  flex-col  '>
          {key === 'incidentReport' && value ? (
            <div className='-mx-42 w-full'>
              <Button
                variant='filled'
                color='secondary'
                className='cursor-pointer py-0 text-primary-default'
                size='full'
                onClick={() =>
                  isDemoFarm
                    ? openModal(<DemoCTA />)
                    : showReportClickHandler(value ? Number(value) : null)
                }
              >
                <Typography
                  variant='body2'
                  weight='bold'
                  className='cursor-pointer text-primary-default'
                >
                  {t('show-report')}
                </Typography>
              </Button>
            </div>
          ) : key === 'worker_rate' ? (
            // worker.unitsAchieved
            <Typography
              variant='subtitle2'
              className={`${
                Number(value) < target
                  ? 'text-error-default'
                  : value === target
                  ? 'text-text-default'
                  : 'text-secondary-900'
              }`}
            >
              {value ? `${value} ${productivityMeasurementUnit}` : '-'}
            </Typography>
          ) : (
            <Typography variant='subtitle2' className='text-text-default'>
              {value || '-'}
            </Typography>
          )}
        </div>
      ))}
      <IncidentReportModal
        open={openIncedentModal}
        closeModal={closeModalHandler}
        incidentReportId={incidentReportId}
      />
    </div>
  );
};

export default TeamMember;
